import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { BillModel, PaymentBillItemPendingModel } from '@data-layer/models/payments';
import { SupportBillsModel } from '@data-layer/models/payments/support-bill-item-model';
import { HttpErrorResponse } from '@angular/common/http';
import { enumRespErrors } from '@data-layer/enums/common';
import { enumPaymentProvider } from '@data-layer/enums/payments';
import { isDefined } from '@services/utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class LCLBillsRepository {
  constructor(private apiService: ApiService) {}

  public pendingBills(
    companyId: number,
    referenceNumbers: string[],
    paymentProvider: enumPaymentProvider,
    paymentCodeId: number,
    coupon: string,
    isCalculateFee: boolean = false,
    isShowLoader?: boolean,
    paymentMethodId?: number,
  ): Observable<PaymentBillItemPendingModel> {
    return this.apiService.get<PaymentBillItemPendingModel>(
      `${environment.url.freight.companiesV3}/${companyId}/pending-bills`,
      {
        params: {
          referenceNumbers,
          ...(isDefined(paymentProvider) && { paymentProvider }),
          ...(isDefined(paymentCodeId) && { paymentCodeId }),
          ...(isDefined(paymentMethodId) && { paymentMethodId }),
          ...(!!coupon && { coupon }),
          isCalculateFee,
        },
      },
      { isShowLoader },
    );
  }

  public create(
    companyId: number,
    referenceNumbers: string[],
    paymentProvider: enumPaymentProvider,
    paymentCodeId: number,
    billToId: number,
    coupon: string,
    paymentMethodId?: number,
  ): Observable<BillModel[]> {
    return this.apiService.post<BillModel[]>(`${environment.url.freight.companiesV3}/${companyId}/bills`, {
      referenceNumbers,
      ...(isDefined(paymentProvider) && { paymentProvider }),
      ...(isDefined(paymentCodeId) && { paymentCodeId }),
      ...(isDefined(paymentMethodId) && { paymentMethodId }),
      ...(isDefined(billToId) && { billToId }),
      ...(!!coupon && { coupon }),
    });
  }

  public getSupportBills(shipmentId: number, isShowLoader: boolean = false): Observable<SupportBillsModel> {
    return this.apiService.get<SupportBillsModel>(`${environment.url.freight.shipmentsManagement}/${shipmentId}/charges`, null, {
      isShowLoader,
    });
  }

  public getErrorMessage(error: HttpErrorResponse): string {
    if (error?.error) {
      switch (error.error.tag) {
        case enumRespErrors.DiscountUnauthorized:
          return 'DISCOUNT_IS_NOT_AUTHORISED';
        case enumRespErrors.DiscountIsNotActive:
          return 'DISCOUNT_IS_NOT_ACTIVE';
        case enumRespErrors.DiscountCannotBeApplied:
          return 'DISCOUNT_CANNOT_BE_APPLIED';
        case enumRespErrors.DiscountNotFound:
          return 'DISCOUNT_IS_NOT_FOUND';
        default:
          break;
      }
    }
  }
}
